import React, { Component } from 'react'
import { connect } from 'cerebral-view-react'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Field from '../inputs/field'
import Device from './helper/device'
import { t } from '@billes/translator-client'

class Login extends Component {
  constructor(props) {
    super(props)
    this.createAccount = this.createAccount.bind(this)
  }

  createAccount() {
    const { signals } = this.props
    signals.login.validateRegistrationStep({ currentPage: 'common' })
  }

  onSignIn(e) {
    e.preventDefault()
    const { signals } = this.props
    signals.login.onSignIn()
  }

  renderCreateAccount() {
    const { requestAccess } = this.props
    if (!requestAccess) {
      return null
    }
    return (
      <FlatButton
        onClick={this.createAccount}
        style={{ float: 'right', color: '#a8a8a8', fontSize: 13 }}
        label={t('bus-client.createAccount')}
        labelPosition={'before'}
      />
    )
  }

  render() {
    const { selectedLocale, signals, device } = this.props
    let machine = new Device(device)
    return (
      <div>
        <form onSubmit={e => this.onSignIn(e)}>
          <div style={{ width: machine.getWidth(), clear: 'both' }}>
            <Field
              selectedLocale={selectedLocale}
              path={'client.registrating.current.login.username'}
              label={'bus-client.field.username'}
            />
            <Field
              selectedLocale={selectedLocale}
              path={'client.registrating.current.login.password'}
              label={'bus-client.field.password'}
              autoCompleteType='current-password'
            />
          </div>
          <div style={{ paddingTop: 20 }}>
            <RaisedButton label={t('bus-client.signIn')} type={'submit'} />
          </div>
        </form>
        <div style={{ paddingTop: 50 }}>
          <FlatButton
            style={{ color: '#a8a8a8', fontSize: 13 }}
            label={t('bus-client.forgotPassword')}
            labelPosition={'after'}
            onClick={() => signals.login.forgotPassword()}
          />
          {this.renderCreateAccount()}
        </div>
      </div>
    )
  }
}

export default connect({
  form: 'client.registrating.current.login',
  selectedLocale: 'client.selectedLocale',
  requestAccess: 'client.requestAccess',
  device: 'useragent.device.type'
})(Login)



// WEBPACK FOOTER //
// ./src/components/Login/login.js